import { render, staticRenderFns } from "./TransactionsPage.vue?vue&type=template&id=f80c128c&scoped=true&lang=html&"
import script from "./TransactionsPage.vue?vue&type=script&lang=js&"
export * from "./TransactionsPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsPage.vue?vue&type=style&index=0&id=f80c128c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80c128c",
  null
  
)

export default component.exports